import React from 'react';
import Translator from '../../../core/i18n';

const T = Translator.create();

const SearchInput = (props: any) => {
    const { isSearchBoxOpen, triggerSearchBox, onChange, onKeyUp } = props
    return (
        <div className={`searchBox ${isSearchBoxOpen ? "active" : ""}`}>
            <button className="searchbar" onClick={() => triggerSearchBox(true)} >
                <i className="material-icons">search</i>
            </button>

            <div className="searchInput">
                <input
                    type="text"
                    placeholder={T.t('r_gen_search')}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event)}
                    onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => {
                        if (event.key === 'Enter') {
                            onKeyUp(event);
                        }
                    }}
                />
            </div>
            <button className="close" onClick={() => triggerSearchBox(false)}>
                <i className="material-icons" >close</i>
            </button>
        </div>
    )
};

export default SearchInput;
